import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useAuth } from '../hooks/useAuth';
import OrderHistory from './OrderHistory';
import SignedAgreements from './SignedAgreements';
import ESignature from './ESignature';

const AttorneyDashboard = () => {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(true);
  const [activeOrders, setActiveOrders] = useState([]);
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    fetchActiveOrders();
  }, []);

  const fetchActiveOrders = async () => {
    try {
      const res = await api.get('/orders/active.php');
      setActiveOrders(res.data.active_orders || []);
    } catch (err) {
      console.error('Failed to load active orders', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Loading dashboard...</div>;

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h2>Welcome, {user?.first_name} {user?.last_name}</h2>
        <button onClick={logout} className="logout-btn">Logout</button>
      </header>

      <div className="dashboard-tabs">
        <button 
          className={activeTab === 'dashboard' ? 'tab-active' : ''} 
          onClick={() => setActiveTab('dashboard')}
        >
          Dashboard
        </button>
        <button 
          className={activeTab === 'orders' ? 'tab-active' : ''} 
          onClick={() => setActiveTab('orders')}
        >
          Orders
        </button>
        <button 
          className={activeTab === 'esign' ? 'tab-active' : ''} 
          onClick={() => setActiveTab('esign')}
        >
          Sign Agreement
        </button>
        <button 
          className={activeTab === 'agreements' ? 'tab-active' : ''} 
          onClick={() => setActiveTab('agreements')}
        >
          Signed Agreements
        </button>
      </div>

      {activeTab === 'dashboard' && (
        <>
          {activeOrders.length === 0 ? (
            <div className="empty-state">No active orders yet. Please contact support to purchase a package.</div>
          ) : (
            <div className="orders-grid">
              {activeOrders.map(order => (
                <div key={order.id} className="order-card">
                  <div className="order-header">
                    <h4>Order #{order.id}</h4>
                    <span className={`badge ${order.payment_status === 'paid' ? 'paid' : 'pending'}`}>
                      {order.payment_status}
                    </span>
                  </div>
                  <div className="order-details">
                    <p><strong>Date:</strong> {new Date(order.order_date).toLocaleDateString()}</p>
                    <p><strong>Package:</strong> {order.pricing_model_name} ({order.pricing_model_code.toUpperCase()})</p>
                    <p><strong>Prepaid:</strong> {order.prepaid_quantity} units</p>
                    <p><strong>Delivered:</strong> {order.delivered_count} {order.pricing_model_code === 'cpa' ? 'retainers signed' : 'leads'}</p>
                    <p className="remaining"><strong>Remaining:</strong> {order.remaining} units</p>
                    <p><strong>Total paid:</strong> ${order.total_amount}</p>
                  </div>
                  {order.pricing_model_code === 'cpa' && (
                    <div className="order-footer">
                      <small>Retainers signed: {order.retainer_signed_count}</small>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {activeTab === 'orders' && <OrderHistory />}
      {activeTab === 'esign' && <ESignature attorneyId={user?.id} templateId={1} />}
      {activeTab === 'agreements' && <SignedAgreements />}
    </div>
  );
};

export default AttorneyDashboard;